import { createContext, useState } from "react";
import dayjs from "dayjs";

export const OrderbumpsContext = createContext();

export const OrderbumpsProvider = ({ children }) => {

    const [products, setProducts] = useState([]); // Estado que armazena a lista de produtos existentes
    const [idProduct, setIdProduct] = useState(""); // Estado que armazena o ID do produto selecionado pelo usuário
    const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf("month").format("YYYY-MM-DD")); // Estado que armazena a data inicial selecionada pelo usuário como filtro de pesquisa
    const [endDateFilter, setEndDateFilter] = useState(dayjs().format("YYYY-MM-DD")); // Estado que armazena a data final selecionada pelo usuário como filtro de pesquisa
    const [data, setData] = useState(null); // Estado que armazena os Dados da busca feita pelo usuário
    const [transactions, setTransactions] = useState([]); // Estado que armazena a lista de transações existentes
    const [orderbumps, setOrderbumps] = useState([]);


    return (
        <OrderbumpsContext.Provider value={{
            products, setProducts, idProduct, setIdProduct, startDateFilter, setStartDateFilter, endDateFilter, setEndDateFilter,
            data, setData, transactions, setTransactions, orderbumps, setOrderbumps
        }}>
            {children}
        </OrderbumpsContext.Provider>
    );
};